<script lang="ts">
import { defineComponent, version } from 'vue'
import Pagination from 'vue-pagination-2'

export default defineComponent({
  name: 'UePagination',
  render(h) {
    if (version.startsWith('3.')) {
      // when using Vue 3, we need to use the new Pagination component
      // https://www.npmjs.com/package/v-pagination-3
      throw new Error('UePagination for Vue 3 is not implemented')
    }

    return h(Pagination, {
      props: this.$attrs,
      on: this.$listeners,
      attrs: this.$attrs,
      scopedSlots: this.$scopedSlots,
    })
  },
})
</script>
